import React from "react";
import BotCard from "./BotCard";

function YourBotArmy({ army }) {
    return(
        <div className="container">
            <h2>Your Bot Army</h2>
            
            <div className="list">
                {army.map(bot => (
                    <span key={bot.id}>
                        <BotCard bot={bot} />
                    </span>
                ))}
            </div>
        </div>
    )
}

export default YourBotArmy;
